/**
 * @description Generates a Stay22 URL with the given parameters.
 * @param {Object} params - The parameters for the Stay22 URL.
 * @param {string} params.campaign - The campaign identifier.
 * @param {string} [params.address] - The address to search for.
 * @param {string} [params.checkin] - The check-in date in YYYY-MM-DD format.
 * @param {string} [params.checkout] - The check-out date in YYYY-MM-DD format.
 * @returns {string} The generated Stay22 URL.
 */
export const createStay22Url = (params: {
  campaign: string;
  address?: string;
  checkin?: string;
  checkout?: string;
}): string => {
  const { address, campaign, checkin, checkout } = params;

  const baseUrl = 'https://www.stay22.com/allez/roam';
  const searchParams = new URLSearchParams({
    aid: 'tictactrip',
    campaign,
  });

  if (address) searchParams.append('address', address);
  if (checkin) searchParams.append('checkin', checkin);
  if (checkout) searchParams.append('checkout', checkout);

  return `${baseUrl}?${searchParams.toString()}`;
};
